$(function () {
    var breakpointType = null;

    function offsetMainContent() {
        if ($(window).innerWidth() < 1200) {
            var heightTop = $('.top').outerHeight();
            $('.main-content').css({
                'top': heightTop + 'px',
                'margin-bottom': heightTop + 'px'
            });
            $('.top').css('position', 'fixed');
        } else {
            var heightTop = $('.top').outerHeight();
            $('.main-content').css({
                'top': '',
                'margin-bottom': ''
            });
            $('.top').css('position', 'fixed');
        }
    }

    function updateMobileMenu() {
        if (jQuery(window).innerWidth() < 900) {
            if (
                window.scrollY >
                jQuery('.contact-bar').height() + jQuery('.cc-grower').height()
            ) {
                jQuery('.contact-bar').hide();
                jQuery('.main-header').addClass('main-header--small');
            } else {
                jQuery('.contact-bar').show();
                jQuery('.main-header').removeClass('main-header--small');
            }
        } else {
            jQuery('.contact-bar').hide();
        }
    }

    jQuery(window).on('scroll', function() {
        updateMobileMenu();
    });

    jQuery(window).on('resize', function() {
        var currentBreakpointType = null;

        var width = window.innerWidth;
        if (width < 900) {
            currentBreakpointType = 'mobile';
        }

        if (width >= 900 && width < 1200) {
            currentBreakpointType = 'tablet';
        }

        if (width >= 1200) {
            currentBreakpointType = 'desktop';
        }

        var breakpointTypeHasChanged = currentBreakpointType !== breakpointType;
        if (breakpointTypeHasChanged) {
            updateMobileMenu();
            offsetMainContent();
            breakpointType = currentBreakpointType;
        }
    });

    offsetMainContent();
    updateMobileMenu();
});